import PropTypes from 'prop-types'
import {Box, Text, Flex, Divider, Link} from '@chakra-ui/react'
import i18next from 'i18next'
import {useTranslation, Trans} from 'react-i18next'
import BillsTable from '~/react/components/BillsTable'

const BILL_STATUSES_HELP_URL =
  'https://marmalade.ladesk.com/450670-What-do-the-bill-and-payment-statuses-mean'

export const PayBillsTab = ({supplierId}) => {
  i18next.loadNamespaces('pointsOnPayments')
  const {t} = useTranslation()

  return (
    <Box display="flex" flexDirection="column">
      <Flex direction="column" gap="sm" mt="md">
        <Flex justify="space-between">
          <Text textStyle="headline3" color="black">
            <Flex alignItems="center" gap="xs" className="fs-unmask">
              {t('pointsOnPayments:bill.tabs.payBills.subTitle')}
            </Flex>
          </Text>
        </Flex>

        <Flex>
          <Text textStyle="body-small" color="gray.500">
            <Trans
              t={t}
              i18nKey="pointsOnPayments:bill.tabs.payBills.body"
              components={{
                Link: (
                  <Link
                    href={BILL_STATUSES_HELP_URL}
                    isExternal
                    variant="primary"
                    color="gray.500"
                  />
                ),
              }}
            />
          </Text>
        </Flex>
      </Flex>

      <Divider my="sm" mb={0} />

      <BillsTable supplierId={supplierId} />
    </Box>
  )
}

PayBillsTab.propTypes = {
  supplierId: PropTypes.string.isRequired,
}

export default PayBillsTab
